import { render, staticRenderFns } from "./BranchListCreate.vue?vue&type=template&id=01b16371&"
import script from "./BranchListCreate.vue?vue&type=script&lang=js&"
export * from "./BranchListCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports